// src/utils/api.js
import axios from "axios";
import { Navigate } from "react-router-dom";
const api = axios.create({
  baseURL: "https://apiresidency.waveplus.dev/api",
  // baseURL: "http://127.0.0.1:8000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Add Bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear invalid/expired token
      localStorage.removeItem("token");
      localStorage.removeItem("user");

       <Navigate to="/unauthorized" replace />
    }
    return Promise.reject(error);
  }
);

export default api;